export default __webpack_public_path__ + "static/media/category-icon-Program.ec0deee2.svg";